<template>
    <div class="">

        <div v-if="$store.state.numberOfUnseenEnquiries > 0" class="bg-red-50 p-4">
          <div class="flex items-center">
            <div class="flex-shrink-0">
              <span class="relative flex h-2.5 w-2.5">
                <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500"></span>
              </span>
            </div>
            <div class="mx-3">
              <h3 class="text-sm font-medium text-red-800">
                You have <strong>{{ $store.state.numberOfUnseenEnquiries }}</strong> unread {{ $store.state.numberOfUnseenEnquiries === 1 ? 'enquiry' : 'enquiries' }}.
              </h3>
            </div>
            <tti-button @click="$router.push('/my-account/enquiries')" size="xsmall" class="ml-4">View</tti-button>
          </div>
        </div>


        <div>
          <div v-if="!!$store.state.user.Published" class="p-4 space-y-2 text-sm text-gray-700 bg-gray-50 sm:flex sm:justify-between sm:items-center sm:space-y-0 sm:p-6">
            <span>Your profile URL: <a :href="`/${publicProfileUrl}`" class="text-blue-600 underline">{{ publicProfileUrl }}</a></span>
            <button v-if="navigatorAvailable" type="button" @click="onShare" class="flex items-center space-x-1 text-sm text-gray-400 hover:text-gray-600">
              <share-icon class="w-5 h-5"></share-icon> 
              <span>Share</span>
            </button>
          </div>


            <!-- Profile section -->
            <form @submit.prevent="onSaveAboutYou" class="py-6 px-4 sm:p-6 lg:pb-8">
              <div>
                <h2 class="text-lg leading-6 font-medium text-gray-900">About You</h2>
                <!-- <p class="mt-1 text-sm text-gray-500">
                  A little bit about you.
                </p> -->
              </div>

              <div class="mt-6 flex flex-col-reverse lg:flex-row">
                <div class="flex-grow space-y-6 grid grid-cols-12 mt-6 lg:mt-0">
                  
                  <div class="col-span-12 sm:col-span-11">
                    <label for="name" class="block text-sm font-medium text-gray-700">
                      Name
                    </label>
                    <div class="mt-1 rounded-md shadow-sm flex">
                      <input v-model="profile.Name" @blur="onNameBlur" name="name" id="name" autocomplete="name" class="focus:ring-light-blue-500 focus:border-light-blue-500 flex-grow block w-full min-w-0 border border-gray-300 rounded-md shadow-sm py-2 px-3 sm:text-sm border-gray-300 placeholder-gray-400" placeholder="e.g. Dr John Smith" />
                    </div>
                    <p class="mt-2 text-sm text-gray-500">
                      Your full name, optionally with title. Do not include any qualifications.
                      <span class="block text-xs">
                        <heroicon icon="check" class="w-4 h-4 inline-block text-green-600"></heroicon> Dr Jane Doe, John Smith<br />
                        <heroicon icon="x" class="w-4 h-4 inline-block text-red-600"></heroicon> Dr J Doe, John Smith MSc, Harriet
                      </span>
                    </p>
                    <p v-if="!$v.profile.Name.required" class="mt-2 text-sm text-red-600">Please enter your name.</p>
                  </div>
                  <div class="col-span-12 sm:col-span-11">
                    <label for="email" class="block text-sm font-medium text-gray-700">
                      Contact Email
                    </label>
                    <div class="mt-1 rounded-md shadow-sm flex">
                      <input v-model="profile.Email" @blur="onEmailBlur" inputmode="email" name="email" id="email" autocomplete="email" class="focus:ring-light-blue-500 focus:border-light-blue-500 flex-grow block w-full min-w-0 border border-gray-300 rounded-md shadow-sm py-2 px-3 sm:text-sm border-gray-300 placeholder-gray-400" placeholder="john.smith@example.com" />
                    </div>
                    <p class="mt-2 text-sm text-gray-500">
                      Enquiries you receive from prospective students will be sent to this email address.
                      <span class="font-semibold">This will not be displayed publicly.</span>
                    </p>
                    <p v-if="!$v.profile.Email.email" class="mt-2 text-sm text-red-600">Please enter a valid email address.</p>
                  </div>

                </div>

                <div class="flex-grow lg:flex-grow-0 lg:flex-shrink-0">
                  <p class="text-sm font-medium text-gray-700" aria-hidden="true">
                    Photo
                  </p>
                  <div v-show="!croppingPhoto" class="mt-1 lg:hidden">
                    <div class="flex items-center">
                      <div class="flex-shrink-0 inline-block rounded-full overflow-hidden h-20 w-20" aria-hidden="true">
                        <img v-if="$store.state.user.Photo" class="rounded-full h-full w-full" :src="$store.state.user.Photo" alt="">
                        <span v-else class="relative block h-20 w-20 rounded-full overflow-hidden bg-gray-100">
                          <svg class="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                          </svg>
                        </span>
                      </div>
                      <div class="ml-5 rounded-md shadow-sm">
                        <div class="group relative border border-gray-300 rounded-md py-2 px-3 flex items-center justify-center hover:bg-gray-50 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-light-blue-500">
                          <label for="user_photo" class="relative text-sm leading-4 font-medium text-gray-700 pointer-events-none">
                            <span>Change</span>
                            <span class="sr-only"> user photo</span>
                          </label>
                          <input @change="croppie" id="user_photo" name="user_photo" type="file" class="absolute w-full h-full opacity-0 cursor-pointer border-gray-300 rounded-md">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-show="!croppingPhoto" class="hidden relative rounded-full overflow-hidden lg:block">
                    <img v-if="$store.state.user.Photo" class="relative rounded-full w-40 h-40" :src="$store.state.user.Photo" alt="" />
                    <span v-else class="relative block h-40 w-40 rounded-full overflow-hidden bg-gray-100">
                      <svg class="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                      </svg>
                    </span>

                    <label for="user-photo" class="absolute inset-0 w-full h-full bg-black bg-opacity-75 flex items-center justify-center text-sm font-medium text-white opacity-0 hover:opacity-100 focus-within:opacity-100">
                      <span>Change</span>
                      <span class="sr-only"> user photo</span>
                      <input type="file" @change="croppie" id="user-photo" name="user-photo" class="absolute inset-0 w-full h-full opacity-0 cursor-pointer border-gray-300 rounded-md">
                    </label>
                  </div>

                  <div v-show="croppingPhoto">
                    <vue-croppie v-show="croppingPhoto" ref="croppieRef" :boundary="{ width: 160, height: 160 }" :viewport="{ width: 160, height: 160, 'type': 'circle' }" :enforce-boundary="true" :enable-resize="false" :max-zoom="1"></vue-croppie>
                    <div class="flex justify-center space-x-2">
                      <tti-button @click="crop">Save</tti-button>
                      <tti-button @click="cancelCrop" theme="outline">Cancel</tti-button>
                    </div>
                  </div>
                </div>
              </div>

            </form>

            <div class="py-6 divide-y divide-gray-200 bg-gray-50">
                <div class="px-4 sm:px-6">
                    <div>
                        <h2 class="text-lg leading-6 font-medium text-gray-900">Your Tutoring Service</h2>
                        <p class="mt-1 text-sm text-gray-500">
                          Explain a bit about the tutoring service you provide.
                        </p>
                    </div>

                    <div class="mt-6 grid grid-cols-12 gap-y-6">

                        <form @submit.prevent="onSaveBio" class="col-span-12">
                          <label for="bio" class="block text-sm font-medium text-gray-700">Bio</label>
                          <textarea v-model="profile.Bio" id="bio" name="bio" rows="3" class="shadow-sm focus:ring-light-blue-500 focus:border-light-blue-500 mt-2 block w-full sm:text-sm border-gray-300 rounded-md"></textarea>
                          <div class="flex flex-col flex-col-reverse sm:flex sm:flex-row sm:justify-between sm:space-x-3 sm:items-start">
                            <p class="mt-2 text-sm text-gray-500">Introduce yourself. This will be shown when you appear in search results.</p>
                            <div v-if="profile.Bio !== $store.state.user.Bio" class="mt-2 space-x-2 flex-shrink-0 sm:flex sm:flex-row-reverse sm:space-x-reverse">
                              <tti-button type="submit" size="xsmall" :loading="savingBio" :disabled="savingBio">Save</tti-button>
                              <tti-button @click="profile.Bio = $store.state.user.Bio" size="xsmall" theme="outline" :disabled="savingBio">Cancel</tti-button>
                            </div>
                          </div>
                        </form>

                        <form @submit.prevent="onSaveApproachToTeaching" class="col-span-12">
                          <label for="approachtoteaching" class="block text-sm font-medium text-gray-700">Approach To Teaching</label>
                          <textarea v-model="profile.ApproachToTeaching" id="approachtoteaching" name="approachtoteaching" rows="3" class="shadow-sm focus:ring-light-blue-500 focus:border-light-blue-500 mt-2 block w-full sm:text-sm border-gray-300 rounded-md"></textarea>
                          <div class="flex flex-col flex-col-reverse sm:flex sm:flex-row sm:justify-between sm:space-x-3 sm:items-start">
                            <p class="mt-2 text-sm text-gray-500">Let potential students know your teaching methods and how they are likely to learn.</p>
                            <div v-if="profile.ApproachToTeaching !== $store.state.user.ApproachToTeaching" class="mt-2 space-x-2 flex-shrink-0 sm:flex sm:flex-row-reverse sm:space-x-reverse">
                              <tti-button type="submit" size="xsmall" :loading="savingApproachToTeaching" :disabled="savingApproachToTeaching">Save</tti-button>
                              <tti-button @click="profile.ApproachToTeaching = $store.state.user.ApproachToTeaching" size="xsmall" theme="outline" :disabled="savingApproachToTeaching">Cancel</tti-button>
                            </div>
                          </div>
                        </form>

                        <form @submit.prevent="onSaveTeachingExperience" class="col-span-12">
                          <label for="teachingexperience" class="block text-sm font-medium text-gray-700">Teaching Experience</label>
                          <textarea v-model="profile.TeachingExperience" id="teachingexperience" name="teachingexperience" rows="3" class="shadow-sm focus:ring-light-blue-500 focus:border-light-blue-500 mt-2 block w-full sm:text-sm border-gray-300 rounded-md"></textarea>
                          <div class="flex flex-col flex-col-reverse sm:flex sm:flex-row sm:justify-between sm:space-x-3 sm:items-start">
                            <p class="mt-2 text-sm text-gray-500">An opportunity to inform prospective students about the experience you have and how that will help your teaching style.</p>
                            <div v-if="profile.TeachingExperience !== $store.state.user.TeachingExperience" class="mt-2 space-x-2 flex-shrink-0 sm:flex sm:flex-row-reverse sm:space-x-reverse">
                              <tti-button type="submit" size="xsmall" :loading="savingTeachingExperience" :disabled="savingTeachingExperience">Save</tti-button>
                              <tti-button @click="profile.TeachingExperience = $store.state.user.TeachingExperience" size="xsmall" theme="outline" :disabled="savingTeachingExperience">Cancel</tti-button>
                            </div>
                          </div>
                        </form>

                    </div>

                </div>
            </div>

            <div class="py-6 divide-y divide-gray-200">
                <div class="px-4 sm:px-6">
                    <div>
                        <h2 class="text-lg leading-6 font-medium text-gray-900">Your Online Presence</h2>
                        <p class="mt-1 text-sm text-gray-500">
                          Link through to your website and social media.
                        </p>
                    </div>

                    <div class="mt-6 grid grid-cols-12 gap-y-6 lg:gap-6">

                        <div class="col-span-12 lg:col-span-6">
                          <label for="website" class="block text-sm font-medium text-gray-700">Website</label>
                          <input v-model="profile.Website" @blur="onWebsiteBlur" inputmode="url" id="website" name="website" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm placeholder-gray-400" placeholder="https://www.mytutoringwebsite.com" />
                          <p v-if="!$v.profile.Website.url" class="mt-2 text-sm text-red-600">Please enter a valid website address.</p>
                        </div>

                        <div class="col-span-12 lg:col-span-6">
                          <label for="facebook" class="block text-sm font-medium text-gray-700">Facebook Page / Profile</label>
                          <input v-model="profile.Facebook" @blur="onFacebookBlur" inputmode="url" id="facebook" name="facebook" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm placeholder-gray-400" placeholder="https://www.facebook.com/mytutoringpage" />
                          <p v-if="!$v.profile.Facebook.url" class="mt-2 text-sm text-red-600">Please enter a valid Facebook URL.</p>
                        </div>

                        <div class="col-span-12 lg:col-span-6">
                          <label for="instagram" class="block text-sm font-medium text-gray-700">Instagram</label>
                          <input v-model="profile.Instagram" @blur="onInstagramBlur" inputmode="url" id="instagram" name="instagram" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm placeholder-gray-400" placeholder="https://www.instagram.com/mytutoringpage" />
                          <p v-if="!$v.profile.Instagram.url" class="mt-2 text-sm text-red-600">Please enter a valid Instagram URL.</p>
                        </div>

                        <div class="col-span-12 lg:col-span-6">
                          <label for="twitter" class="block text-sm font-medium text-gray-700">Twitter</label>
                          <input v-model="profile.Twitter" @blur="onTwitterBlur" inputmode="url" id="twitter" name="twitter" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm placeholder-gray-400" placeholder="https://www.twitter.com/mytutoringpage" />
                          <p v-if="!$v.profile.Twitter.url" class="mt-2 text-sm text-red-600">Please enter a valid Twitter URL.</p>
                        </div>

                        <div class="col-span-12 lg:col-span-6">
                          <label for="linkedin" class="block text-sm font-medium text-gray-700">LinkedIn</label>
                          <input v-model="profile.LinkedIn" @blur="onLinkedInBlur" inputmode="url" id="linkedin" name="linkedin" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm placeholder-gray-400" placeholder="https://www.linkedin.com/mytutoringpage" />
                          <p v-if="!$v.profile.LinkedIn.url" class="mt-2 text-sm text-red-600">Please enter a valid LinkedIn URL.</p>
                        </div>

                        <div class="col-span-12 lg:col-span-6">
                          <label for="youtube" class="block text-sm font-medium text-gray-700">YouTube</label>
                          <input v-model="profile.YouTube" @blur="onYouTubeBlur" inputmode="url" id="youtube" name="youtube" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm placeholder-gray-400" placeholder="https://www.youtube.com/user/mytutoringpage" />
                          <p v-if="!$v.profile.YouTube.url" class="mt-2 text-sm text-red-600">Please enter a valid YouTube URL.</p>
                        </div>

                    </div>

                </div>
            </div>



            <!-- Privacy section -->
            <div class="py-6 divide-y divide-gray-200 bg-gray-50">
              <div class="px-4 sm:px-6">
                <div>
                  <h2 class="text-lg leading-6 font-medium text-gray-900">Preferences</h2>
                  <!-- <p class="mt-1 text-sm text-gray-500">
                    Ornare eu a volutpat eget vulputate. Fringilla commodo amet.
                  </p> -->
                </div>
                <ul class="mt-2 divide-y divide-gray-200">
                  <li @click="toggleTeachOnline()" class="py-4 flex items-center justify-between space-x-2">
                    <div class="flex flex-col">
                      <p class="text-sm font-medium text-gray-900" id="privacy-option-1-label">
                        Do you teach online?
                      </p>
                    </div>

                    <tti-toggle :value="$store.state.user.TeachesOnline" @onChange="toggleTeachOnline"></tti-toggle>
                  </li>
                  <li @click="toggleAcceptingNewStudents()" class="py-4 flex items-start justify-between space-x-2">
                    <div class="flex flex-col">
                      <p class="text-sm font-medium text-gray-900" id="privacy-option-1-label">
                        Are you accepting new students?
                      </p>
                      <p class="text-sm text-gray-500" id="privacy-option-1-description">
                        If you aren’t currently taking on new students you can reduce the visibility of your profile to reduce unnecessary enquiries. Your profile will still be visible publicly, but you may not appear as prominently in search results.
                      </p>
                    </div>

                    <tti-toggle :value="$store.state.user.AcceptingNewStudents" @onChange="toggleAcceptingNewStudents"></tti-toggle>
                  </li>
                  <li
                    @click="togglePublished()" 
                    class="py-4 flex items-start justify-between space-x-2"
                  >
                    <div class="flex flex-col">
                      <p class="text-sm font-medium text-gray-900" id="privacy-option-1-label">
                        <template v-if="$store.state.user.HasPassedTtiReview">
                          Profile published
                        </template>
                        <template v-else>
                          Auto-publish profile when complete
                        </template>
                      </p>
                      <p class="text-sm text-gray-500" id="privacy-option-1-description">
                        <template v-if="$store.state.user.HasPassedTtiReview">
                          You can switch your profile between draft and publish mode at any time. If your profile is in draft mode it will not be visible to anyone, even if they know your unique URL. We periodically review profiles for quality and may be in touch if we feel there are issues that need addressing. Check out <router-link to="/articles/our-approach-to-quality" class="text-blue-600 underline">our approach to quality</router-link> to minimise the risk of any interruption.
                        </template>
                        <template v-else>
                          All profiles will go through a mandatory review process before becoming public on our website to ensure it meets our <router-link to="/articles/our-approach-to-quality" class="text-blue-600 underline">expected level of quality</router-link>. We will automatically submit your profile for review when we detect you have filled out the necessary information. If you would rather do this manually, you can disable auto-publishing.
                        </template>
                      </p>
                    </div>

                    <tti-toggle :value="$store.state.user.Published" @onChange="togglePublished"></tti-toggle>
                  </li>
                </ul>
              </div>
              
            </div>
          </div>

    </div>
</template>
<script>

import 'croppie/croppie.css'

import debounce from 'debounce'
import { required, email, url } from 'vuelidate/lib/validators'

import { ShareIcon } from '@vue-hero-icons/solid'

import UserService from '../services/UserServices'
const userService = new UserService();

export default {
    components: {
        'tti-button': () => import('./TailwindButton'),
        'tti-toggle': () => import('./TailwindToggle'),
        'heroicon': () => import('./Heroicon'),
        'vue-croppie': () => import('vue-croppie').then((loader) => { 
          return loader.VueCroppieComponent 
        }),
        ShareIcon
    },
    props: {
      progressComplete: { default: false }
    },
    data() {
        return {
            acceptingNewStudents: false,
            willTeachOnline: false,
            profile: {},
            savingBio: false,
            savingApproachToTeaching: false,
            savingTeachingExperience: false,
            submittingAboutYou: false,
            submittingServices: false,
            submittingOnline: false,
            croppingPhoto: false
        }
    },
    validations: {
      profile: {
        Name: { required },
        Email: { email },
        Website: { url },
        Facebook: { url },
        Instagram: { url },
        Twitter: { url },
        LinkedIn: { url },
        YouTube: { url }
      }
    },
    computed: {
        publicProfileUrl() {
          return `${ this.$store.state.user.PublicId }-${ this.$store.state.user.Name.replace(/ /g, '-').toLowerCase() }`
        },
        navigatorAvailable() {
          return navigator.share !== undefined;
        }
    },
    watch: {
        '$store.state.user'() {
            this.onDataLoaded();
        }
    },
    methods: {
        onDataLoaded() {
            var user = this.$store.state.user;

            if (user === null) return;

            this.profile = Object.assign({}, { 
                Name: user.Name,
                Email: user.Email,
                Bio: user.Bio,
                ApproachToTeaching: user.ApproachToTeaching,
                TeachingExperience: user.TeachingExperience,
                Website: user.Website,
                Facebook: user.Facebook,
                Instagram: user.Instagram,
                Twitter: user.Twitter,
                LinkedIn: user.LinkedIn,
                YouTube: user.YouTube
            });
        },
        async onNameBlur() {
          this.$v.profile.Name.$touch();

          if (this.profile.Name === this.$store.state.user.Name || this.$v.profile.Name.$invalid)
            return;

          await this.$store.dispatch('updateUser', { Name: this.profile.Name });
          this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved.' });
        },
        async onEmailBlur() {
          this.$v.profile.Email.$touch();

          if (this.profile.Email === this.$store.state.user.Email || this.$v.profile.Email.$invalid)
            return;

          await this.$store.dispatch('updateUser', { Email: this.profile.Email });
          this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved.' });
        },
        // onSaveAboutYou() {
          
          
        //   if (this.$v.profile.Name.$invalid || this.$v.profile.Email.$invalid) return;
          
        //     this.submittingAboutYou = true;

        //     this.$store.dispatch('updateUser', {
        //         Name: this.profile.Name,
        //         Email: this.profile.Email
        //     })
        //     .then(() => {
        //         this.submittingAboutYou = false;
        //         this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved' });
        //         this.$refs.submitAboutYouButton.showSuccessState();
        //     });
        // },
        // onCancelAboutYou() {
        //     this.profile = Object.assign({}, this.profile, {
        //         Name: this.$store.state.user.Name,
        //         Email: this.$store.state.user.Email
        //     });
        // },
        async onSaveBio() {
          this.savingBio = true;
          await this.$store.dispatch('updateUser', { Bio: this.profile.Bio })

          this.savingBio = false;
          this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved' });
        },
        async onSaveApproachToTeaching() {
          this.savingApproachToTeaching = true;
          await this.$store.dispatch('updateUser', { ApproachToTeaching: this.profile.ApproachToTeaching });

          this.savingApproachToTeaching = false
          this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved' });
        },
        async onSaveTeachingExperience() {
          await this.$store.dispatch('updateUser', { TeachingExperience: this.profile.TeachingExperience });
          this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved' });
        },
        onSaveService() {
            this.submittingServices = true;

            this.$store.dispatch('updateUser', {
                Bio: this.profile.Bio,
                ApproachToTeaching: this.profile.ApproachToTeaching,
                TeachingExperience: this.profile.TeachingExperience
            })
            .then(() => {
                this.submittingServices = false;
                this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved' });
                this.$refs.submitServicesButton.showSuccessState();
            });
        },
        onCancelService() {
            this.profile = Object.assign({}, this.profile, {
                Bio: this.$store.state.user.Bio,
                ApproachToTeaching: this.$store.state.user.ApproachToTeaching,
                TeachingExperience: this.$store.state.user.TeachingExperience
            });
        },
        async onWebsiteBlur() {
          this.$v.profile.Website.$touch();

          if (this.profile.Website === this.$store.state.user.Website || this.$v.profile.Website.$invalid)
            return;

          await this.$store.dispatch('updateUser', { Website: this.profile.Website });
          this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved.' });
        },
        async onFacebookBlur() {
          this.$v.profile.Facebook.$touch();

          if (this.profile.Facebook === this.$store.state.user.Facebook || this.$v.profile.Facebook.$invalid)
            return;

          await this.$store.dispatch('updateUser', { Facebook: this.profile.Facebook });
          this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved.' });
        },
        async onInstagramBlur() {
          this.$v.profile.Instagram.$touch();

          if (this.profile.Instagram === this.$store.state.user.Instagram || this.$v.profile.Instagram.$invalid)
            return;

          await this.$store.dispatch('updateUser', { Instagram: this.profile.Instagram });
          this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved.' });
        },
        async onTwitterBlur() {
          this.$v.profile.Twitter.$touch();

          if (this.profile.Twitter === this.$store.state.user.Twitter || this.$v.profile.Twitter.$invalid)
            return;

          await this.$store.dispatch('updateUser', { Twitter: this.profile.Twitter });
          this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved.' });
        },
        async onLinkedInBlur() {
          this.$v.profile.LinkedIn.$touch();

          if (this.profile.LinkedIn === this.$store.state.user.LinkedIn || this.$v.profile.LinkedIn.$invalid)
            return;

          await this.$store.dispatch('updateUser', { LinkedIn: this.profile.LinkedIn });
          this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved.' });
        },
        async onYouTubeBlur() {
          this.$v.profile.YouTube.$touch();

          if (this.profile.YouTube === this.$store.state.user.YouTube || this.$v.profile.YouTube.$invalid)
            return;

          await this.$store.dispatch('updateUser', { YouTube: this.profile.YouTube });
          this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved.' });
        },
        async toggleTeachOnline(newVal) {
          await this.$store.dispatch('updateUser', { TeachesOnline: newVal || !this.$store.state.user.TeachesOnline });
          this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved.' });
        },
        async toggleAcceptingNewStudents(newVal) {
          await this.$store.dispatch('updateUser', { AcceptingNewStudents: newVal || !this.$store.state.user.AcceptingNewStudents });
          this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved.' });
        },
        async togglePublished(newVal) {
          await this.$store.dispatch('updateUser', { Published: newVal || !this.$store.state.user.Published });
          this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved.' });
        },
        croppie (e) {
          var files = e.target.files || e.dataTransfer.files;
          if (!files.length) return;

          var reader = new FileReader();
          reader.onload = e => {
            // Make sure the croppie element is visible on the page before binding
            this.croppingPhoto = true;
            this.$refs.croppieRef.bind({
              url: e.target.result
            });
          };

          reader.readAsDataURL(files[0]);
        },
        crop() {
          let options = {
            type: 'base64',
            size: { width: 500, height: 500 },
            format: 'jpeg'
          };
          
          this.$refs.croppieRef.result(options, output => {
            this.cropped = this.croppieImage = output;
            this.$store.dispatch('updatePhoto', { Photo: this.cropped }).then(() => {
              this.$store.commit('showModal', { icon: 'check-circle', title: 'Saved.' });
              this.croppingPhoto = false;
            });
          });
        },
        cancelCrop() {
          this.croppingPhoto = false;
        },
        onShare() {
          navigator.share({
            title: `Check out my profile on The Tutor Index`,
            url: `https://www.thetutorindex.com/${this.publicProfileUrl}`
          })
        }
    },
    mounted() {
        this.onDataLoaded();
    }
}
</script>
<style>

  .croppie-container .cr-slider-wrap,
  .cr-slider
  {
    width: 160px;
  }

</style>